__webpack_require__.p = "/delete-confirm-dialog/account-setup/";